import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {ResolveCategory} from '../../services/data.service';
import {ExtensionCategory} from '../../../../functions/src/types';
import invert from 'invert-color';

@Component({
  selector: 'app-button-tag',
  templateUrl: './button-tag.component.html',
  styleUrls: ['./button-tag.component.scss']
})
export class ButtonTagComponent implements OnInit {
  @Input() color: string;
  @Input() label: string;
  @Input() icon: string;
  @Input() clickable = false;
  @Input() name = true;
  // @Input() background = true;
  @Output() itemClick = new EventEmitter();
  @Input() highlighted = false;

  ngOnInit(): void { }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

}
